import React from 'react';
import './Policy.css';

const TermsOfUse = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Terms of Use (EULA)</h1>
          <p className="last-updated">Last Updated: December 15, 2025</p>

          <div className="important-links" style={{background: '#f0f8ff', padding: '20px', borderRadius: '8px', marginBottom: '30px', border: '2px solid #007bff'}}>
            <h3 style={{marginTop: 0, color: '#007bff'}}>Important Legal Documents</h3>
            <p style={{marginBottom: '10px'}}><strong>Before using Land Tracker, please review:</strong></p>
            <ul style={{lineHeight: '1.8'}}>
              <li><strong>Terms of Use (EULA):</strong> <a href="https://landtracker.app/terms-of-use" target="_blank" rel="noopener noreferrer" style={{color: '#007bff', textDecoration: 'underline'}}>https://landtracker.app/terms-of-use</a></li>
              <li><strong>Privacy Policy:</strong> <a href="https://landtracker.app/privacy-policy" target="_blank" rel="noopener noreferrer" style={{color: '#007bff', textDecoration: 'underline'}}>https://landtracker.app/privacy-policy</a></li>
            </ul>
            <p style={{fontSize: '14px', color: '#555', marginBottom: 0}}><em>These documents govern your use of the Land Tracker mobile application and describe how we collect, use, and protect your personal information.</em></p>
          </div>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using Land Tracker ("the App"), you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.</p>
            <p>These terms constitute a legally binding agreement between you and Land Tracker. By downloading, installing, or using the App through Apple App Store or Google Play Store, you acknowledge that you have read, understood, and agree to be bound by these terms.</p>
          </section>

          <section>
            <h2>2. User Accounts</h2>
            <p>To use certain features of the App, you must create an account. You agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Be responsible for all activities under your account</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Not share your account with others</li>
              <li>Be at least 18 years of age to create an account</li>
            </ul>
          </section>

          <section>
            <h2>3. Acceptable Use</h2>
            <p>You agree to use the App only for lawful purposes. You shall not:</p>
            <ul>
              <li>Upload false, misleading, or fraudulent information</li>
              <li>Violate any laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Attempt to hack, disrupt, or damage the App</li>
              <li>Use the App for commercial purposes without authorization</li>
              <li>Harass or harm other users</li>
            </ul>
          </section>

          <section>
            <h2>4. Content Ownership</h2>
            <p>You retain ownership of all content you upload to the App (property details, documents, photos). By uploading content, you grant us a license to store, process, and display it as necessary to provide our services.</p>
          </section>

          <section>
            <h2>5. Intellectual Property</h2>
            <p>The App, including its design, features, and content, is protected by copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, or reverse-engineer any part of the App without our permission.</p>
          </section>

          <section>
            <h2>6. Auto-Renewable Subscriptions</h2>
            
            <h3>6.1 Subscription Plans and Duration</h3>
            <p>Land Tracker offers the following auto-renewable subscription plans:</p>
            <ul>
              <li><strong>Starter Plan:</strong> Free - Basic property management features (no subscription required)</li>
              <li><strong>Land Owner Plan - Monthly:</strong> $0.99/month (1-month subscription, automatically renews monthly)</li>
              <li><strong>Land Owner Plan - Yearly:</strong> $9.99/year (12-month subscription, automatically renews yearly)</li>
              <li><strong>Family Estate Plan - Monthly:</strong> $1.99/month (1-month subscription, automatically renews monthly)</li>
              <li><strong>Family Estate Plan - Yearly:</strong> $19.99/year (12-month subscription, automatically renews yearly)</li>
              <li><strong>Pro Landlord Plan - Monthly:</strong> $4.99/month (1-month subscription, automatically renews monthly)</li>
              <li><strong>Pro Landlord Plan - Yearly:</strong> $39.99/year (12-month subscription, automatically renews yearly)</li>
            </ul>
            <p>Prices are in USD and may vary by region. Actual pricing will be displayed in the App Store or Google Play Store in your local currency at the time of purchase.</p>

            <h3>6.2 Payment and Billing</h3>
            <ul>
              <li><strong>iOS Users:</strong> Payment will be charged to your iTunes Account at confirmation of purchase. By purchasing a subscription, you authorize us (and Apple Inc.) to charge your iTunes Account.</li>
              <li><strong>Android Users:</strong> Payment will be charged to your Google Play account at confirmation of purchase. By purchasing a subscription, you authorize us (and Google LLC) to charge your Google Play Account.</li>
              <li>Subscription fees are charged on a recurring basis according to your selected billing cycle (monthly or yearly).</li>
              <li>All payments are processed securely by Apple Inc. (for iOS) or Google LLC (for Android), not directly by Land Tracker. We do not store your payment information.</li>
            </ul>

            <h3>6.3 Automatic Renewal</h3>
            <p>All subscriptions automatically renew unless you cancel. Here's how it works:</p>
            <ul>
              <li>Subscriptions automatically renew unless auto-renew is turned off at least 24 hours before the end of the current period.</li>
              <li>Your account will be charged for renewal within 24 hours prior to the end of the current period, and the cost of the renewal will be identified.</li>
              <li>The renewal charge will be at the same price as the original subscription, unless we notify you of a price change in advance.</li>
              <li>Subscriptions may be managed by the user and auto-renewal may be turned off by going to the user's Account Settings after purchase.</li>
              <li><strong>To manage your subscription on iOS:</strong> Go to Settings → [Your Name] → Subscriptions → Select Land Tracker subscription</li>
              <li><strong>To manage your subscription on Android:</strong> Open Google Play Store → Menu → Subscriptions → Select Land Tracker subscription</li>
            </ul>

            <h3>6.4 Cancellation</h3>
            <p><strong>For iOS Users:</strong></p>
            <ul>
              <li>Open the Settings app on your iOS device</li>
              <li>Tap your name at the top</li>
              <li>Tap "Subscriptions"</li>
              <li>Select Land Tracker subscription</li>
              <li>Tap "Cancel Subscription"</li>
            </ul>

            <p><strong>For Android Users:</strong></p>
            <ul>
              <li>Open the Google Play Store app</li>
              <li>Tap Menu → Subscriptions</li>
              <li>Select Land Tracker subscription</li>
              <li>Tap "Cancel Subscription"</li>
            </ul>

            <p>Cancellation takes effect at the end of the current billing period. You will continue to have access to subscription features until the end of your current billing period.</p>

            <h3>6.5 Free Trials and Promotional Offers</h3>
            <ul>
              <li>We may offer free trial periods for new subscribers. The trial duration will be clearly displayed before you subscribe.</li>
              <li>If a free trial is offered, you will be charged the full subscription price at the end of the trial period unless you cancel at least 24 hours before the trial ends.</li>
              <li>Any unused portion of a free trial period, if offered, will be forfeited when the user purchases a subscription to that publication, where applicable.</li>
              <li>Free trials are generally available only once per user and cannot be combined with other promotional offers unless explicitly stated.</li>
              <li>We reserve the right to modify or discontinue free trial offers at any time without notice.</li>
            </ul>

            <h3>6.6 Refunds</h3>
            <ul>
              <li><strong>iOS Users:</strong> All sales are final. Refund requests must be submitted directly to Apple through the App Store. Land Tracker cannot process refunds for iOS purchases</li>
              <li><strong>Android Users:</strong> Refund requests must be submitted to Google Play. Refunds are subject to Google Play's refund policy</li>
              <li>We cannot guarantee that refund requests will be approved</li>
              <li>For billing issues or disputes, please contact our support team at support@landtracker.app</li>
            </ul>

            <h3>6.7 Price Changes</h3>
            <ul>
              <li>We reserve the right to change subscription prices at any time</li>
              <li>You will be notified of any price changes at least 30 days in advance</li>
              <li>Price changes will take effect on your next renewal date</li>
              <li>Continuing to use the service after a price change constitutes acceptance of the new price</li>
            </ul>

            <h3>6.8 Subscription Features</h3>
            <p>Subscription features may include but are not limited to:</p>
            <ul>
              <li>Unlimited property tracking</li>
              <li>AI-powered satellite monitoring</li>
              <li>Advanced document storage</li>
              <li>Family sharing capabilities</li>
              <li>Priority customer support</li>
              <li>Ad-free experience</li>
            </ul>
            <p>Features are subject to change. We will make reasonable efforts to notify you of significant feature changes.</p>
          </section>

          <section>
            <h2>7. Platform-Specific Terms</h2>
            
            <h3>7.1 Apple App Store</h3>
            <p>If you download the App from the Apple App Store, the following additional terms apply:</p>
            <ul>
              <li>These Terms are between you and Land Tracker, not Apple Inc.</li>
              <li>Apple has no obligation to provide maintenance or support services</li>
              <li>Apple is not responsible for the App or its content</li>
              <li>Apple is not responsible for addressing any claims relating to the App</li>
              <li>Apple is a third-party beneficiary of these Terms and may enforce them</li>
              <li>You must comply with all applicable third-party terms when using the App</li>
              <li>The license granted is limited to a non-transferable license to use the App on Apple-branded products you own or control</li>
            </ul>

            <h3>7.2 Google Play Store</h3>
            <p>If you download the App from Google Play, the following additional terms apply:</p>
            <ul>
              <li>You must comply with Google Play Terms of Service</li>
              <li>Google LLC is a third-party beneficiary of these Terms as they relate to your use of the App through Google Play</li>
              <li>Google is not responsible for the App, its content, or these Terms</li>
            </ul>
          </section>

          <section>
            <h2>8. Disclaimer of Warranties</h2>
            <p>The App is provided "as is" without warranties of any kind, either express or implied. We do not guarantee that:</p>
            <ul>
              <li>The App will be error-free or uninterrupted</li>
              <li>Data will be completely secure from loss or corruption</li>
              <li>The App will meet your specific requirements</li>
              <li>Defects will be corrected</li>
              <li>Satellite imagery or property data will be accurate, current, or complete</li>
            </ul>
            <p>You use the App at your own risk. We disclaim all warranties, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law:</p>
            <ul>
              <li>We shall not be liable for any indirect, incidental, special, consequential, or punitive damages</li>
              <li>Our total liability shall not exceed the amount you paid for the subscription in the 12 months preceding the claim</li>
              <li>We are not liable for losses resulting from unauthorized access to your account</li>
              <li>We are not liable for decisions made based on information provided by the App</li>
            </ul>
            <p>Some jurisdictions do not allow the exclusion of certain warranties or limitation of liability, so the above limitations may not apply to you.</p>
          </section>

          <section>
            <h2>10. Indemnification</h2>
            <p>You agree to indemnify and hold harmless Land Tracker, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including legal fees) arising from:</p>
            <ul>
              <li>Your use of the App</li>
              <li>Your violation of these Terms</li>
              <li>Your violation of any rights of another party</li>
              <li>Content you upload to the App</li>
            </ul>
          </section>

          <section>
            <h2>11. Data Privacy and Security</h2>
            <p>Your use of the App is also governed by our Privacy Policy, available at <a href="https://landtracker.app/privacy-policy" target="_blank" rel="noopener noreferrer">https://landtracker.app/privacy-policy</a>. We implement industry-standard security measures, but cannot guarantee absolute security. You are responsible for maintaining the confidentiality of your account credentials.</p>
          </section>

          <section>
            <h2>12. Termination</h2>
            <p>We reserve the right to suspend or terminate your account if you:</p>
            <ul>
              <li>Violate these Terms of Use</li>
              <li>Engage in fraudulent or harmful behavior</li>
              <li>Fail to pay subscription fees</li>
              <li>Abuse or misuse the App</li>
            </ul>
            <p>Upon termination:</p>
            <ul>
              <li>Your right to use the App will immediately cease</li>
              <li>We may delete your account and data</li>
              <li>You will not be entitled to a refund of any prepaid fees</li>
              <li>You must stop using the App and delete all copies</li>
            </ul>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>We may update these Terms of Use from time to time. We will notify you of material changes via:</p>
            <ul>
              <li>In-app notification</li>
              <li>Email to your registered address</li>
              <li>Update notice on our website</li>
            </ul>
            <p>Continued use of the App after changes constitutes acceptance of the new terms. If you do not agree to the changes, you must stop using the App and cancel your subscription.</p>
          </section>

          <section>
            <h2>14. Governing Law and Dispute Resolution</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to conflict of law principles.</p>
            <p>Any disputes arising from these Terms or your use of the App shall be resolved through:</p>
            <ul>
              <li>Good faith negotiations between the parties</li>
              <li>If negotiations fail, binding arbitration in accordance with applicable arbitration rules</li>
              <li>You waive any right to participate in class action lawsuits</li>
            </ul>
          </section>

          <section>
            <h2>15. Severability</h2>
            <p>If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.</p>
          </section>

          <section>
            <h2>16. Entire Agreement</h2>
            <p>These Terms, together with our Privacy Policy (<a href="https://landtracker.app/privacy-policy" target="_blank" rel="noopener noreferrer">https://landtracker.app/privacy-policy</a>), constitute the entire agreement between you and Land Tracker regarding the use of the App and supersede all prior agreements and understandings.</p>
          </section>

          <section>
            <h2>17. Contact Information</h2>
            <p>For questions about these Terms of Use, subscription billing, or technical support, contact us at:</p>
            <ul>
              <li><strong>Customer Support:</strong> support@landtracker.app</li>
              <li><strong>Subscription & Billing Support:</strong> billing@landtracker.app</li>
              <li><strong>Legal Inquiries:</strong> legal@landtracker.app</li>
              <li><strong>Privacy Concerns:</strong> privacy@landtracker.app</li>
              <li><strong>Website:</strong> <a href="https://landtracker.app" target="_blank" rel="noopener noreferrer">https://landtracker.app</a></li>
              <li><strong>Help Center:</strong> <a href="https://landtracker.app/support" target="_blank" rel="noopener noreferrer">https://landtracker.app/support</a></li>
            </ul>
            <p><strong>For iOS Subscription Issues:</strong> If you have issues with billing or subscriptions purchased through the Apple App Store, you can also contact Apple Support directly or request a refund through the App Store.</p>
            <p><strong>For Android Subscription Issues:</strong> If you have issues with billing or subscriptions purchased through Google Play, you can also contact Google Play Support directly.</p>
          </section>

          <section className="acknowledgment">
            <h2>Acknowledgment</h2>
            <p><strong>By using Land Tracker, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use and our Privacy Policy (<a href="https://landtracker.app/privacy-policy" target="_blank" rel="noopener noreferrer">https://landtracker.app/privacy-policy</a>).</strong></p>
            <p>For iOS users: These terms constitute an End User License Agreement (EULA) as required by Apple's App Store Review Guidelines.</p>
            <p>For Android users: These terms comply with Google Play's Developer Program Policies.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
